import React from 'react';
import Countdown from 'react-countdown';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import '@template/components/Timer/Timer.scss';

import '@styles/common/Timer.scss';

function Timer(props) {
    const { t } = useTranslation();

    const countdownRender = ({ minutes, seconds }) => {
        return (
            <span className="timerCountDown">
                {minutes < 10 ? '0' + minutes : minutes}:
                {seconds < 10 ? '0' + seconds : seconds}
            </span>
        );
    };
    return (
        <Box className="timer">
            <Typography>
                {t('common.timerDesc') + ': '}
                <Countdown {...props} renderer={countdownRender} />
            </Typography>
        </Box>
    );
}

export default Timer;
